import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Spinner } from './Spinner';
import {
  makeStyles,
  FormControl,
  InputLabel,
  Select,
  Input,
  MenuItem,
  Checkbox,
  ListItemText
} from '@material-ui/core/';

const useStyles = makeStyles(theme => ({
  formControl: {
    margin: theme.spacing(0),
    minWidth: 175,
    maxWidth: 175
  },
  chips: {
    display: 'block',
    flexWrap: 'wrap'
  },
  chip: {
    margin: 0
  },
  noLabel: {
    marginTop: theme.spacing(1)
  }
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 200
    }
  }
};

export class CampaignsFilterSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      value: props.value,
      label: props.label,
      filterName: props.filterName,
      values: props.values,
      secondaryValues: props.secondaryValues,
      change: props.change,
      id: props.id
    };
    this.handlechange = this.handlechange.bind(this);
  }

  static propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.array.isRequired
  };

  handlechange = name => ({ target: { value } }) => {
    this.setState({
      ...this.state,
      [name]: value
    });
  };

  componentDidMount() {
    this.setState({ loading: true });

    this.setState({ loading: false });
  }

  render() {
    const { loading, label, id } = this.state;
    return loading || this.state.values === undefined ? (
      <Spinner />
    ) : (
      <div>
        <FormControl
          variant='outlined'
          classitem={useStyles.formControl}
          style={{ width: '100%' }}
        >
          <InputLabel shrink htmlFor={label}></InputLabel>

          <Select
            id={id}
            multiple
            value={this.props.value}
            onChange={this.props.onChange(this.props.filterName)}
            input={<Input />}
            renderValue={selected => selected.join(', ')}
            MenuProps={MenuProps}
          >
            {this.props.values.map((name, index) => (
              <MenuItem key={name} value={name}>
                <Checkbox checked={this.props.value.indexOf(name) > -1} />
                <ListItemText
                  primary={name}
                  secondary={this.state.secondaryValues === undefined ? '' : this.state.secondaryValues[index]}
                />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
    );
  }
}

export default CampaignsFilterSelect;
